import getContent from './getContent';
import { createSelector } from 'reselect';
import { get } from 'lodash-es';

export function getArticleBySlug(slug: string) {
  return createSelector(getContent, articles => get(articles, slug));
}

export default getArticleBySlug;
